export class WebGLAssets {
    static layerIndex: number = 0;
    static allLayersSet = false;

    static setImagesOnStart = false;
    static setVideosOnStart = false;
    static setGpuTextOnStart = false;  
}

